"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResources = void 0;
var textures_1 = require("./textures");
var model_1 = require("./model");
var three_1 = require("three");
var GLTFLoader_1 = require("three/examples/jsm/loaders/GLTFLoader");
var gltfLoader = new GLTFLoader_1.GLTFLoader();
var textureLoader = new three_1.TextureLoader();
var cubeTextureLoader = new three_1.CubeTextureLoader();
var getTexture = function (source) {
    var prm = new Promise(function (res, rej) {
        textureLoader.load(source.path, function (texture) {
            res({
                name: source.name,
                content: texture
            });
        }, null, rej);
    });
    return prm;
};
var getCubeTexture = function (source) {
    var prm = new Promise(function (res, rej) {
        cubeTextureLoader.load(source.paths, function (texture) {
            res({
                name: source.name,
                content: texture
            });
        }, null, rej);
    });
    return prm;
};
var getGltf = function (source) {
    var prm = new Promise(function (res, rej) {
        gltfLoader.load(source.path, function (model) {
            res({
                name: source.name,
                content: model
            });
        }, null, rej);
    });
    return prm;
};
var getResources = function () {
    var promiseArr = [];
    var sources = __spreadArray(__spreadArray([], textures_1.textureSources, true), model_1.modelSources, true);
    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
        var source = sources_1[_i];
        switch (source.type) {
            case 'cubeTexture':
                promiseArr.push(getCubeTexture(source));
                break;
            case 'texture':
                promiseArr.push(getTexture(source));
                break;
            case 'gltfModel':
                promiseArr.push(getGltf(source));
                break;
        }
    }
    return Promise.all(promiseArr).then(function (values) {
        var result = {};
        values.forEach(function (sourceObj) {
            result[sourceObj.name] = sourceObj.content;
        });
        return result;
    });
};
exports.getResources = getResources;
